export default "__VITE_ASSET__859f150a__"